var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"caption tabular-nums",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm._f("format_time")(_vm.start))+" - "+_vm._s(_vm._f("format_time")(_vm.end)))])}
var staticRenderFns = []

export { render, staticRenderFns }